import { motion } from "framer-motion";
import { IGlowingBadgeProps } from "Interfaces/interface.uiUtils";

export const GlowingBadge: React.FC<IGlowingBadgeProps> = ({
  icon: Icon,
  text,
  bgColor = "bg-blue-500",
  textColor = "text-white",
  className = "",
  glowColor = "rgba(255,255,255,0.6)",
  animationDuration = 2,
  showGlow = true,
  size = "sm",
}) => {
  const sizeClasses: Record<"sm" | "md" | "lg", string> = {
    sm: "px-2 py-1 text-xs gap-1",
    md: "px-3 py-2 text-sm gap-2",
    lg: "px-4 py-3 text-base gap-3",
  };

  const iconSizes: Record<"sm" | "md" | "lg", string> = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  return (
    <motion.span
      className={`relative inline-flex items-center font-semibold rounded-md overflow-hidden ${bgColor} ${textColor} ${sizeClasses[size]} ${className}`}
      initial={{ opacity: 0, y: -5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {/* Text + Icon layer */}
      <span className="relative z-10 flex items-center">
        {Icon && <Icon className={`${iconSizes[size]} mr-1`} />}
        {text}
      </span>

      {/* Animated Glow Layer */}
      {showGlow && (
        <motion.div
          className="absolute left-[-50%] top-0 w-[200%] h-full"
          style={{
            background: `linear-gradient(to right, transparent, ${glowColor}, transparent)`,
            zIndex: 0,
          }}
          initial={{ x: "-100%" }}
          animate={{ x: "100%" }}
          transition={{
            repeat: Infinity,
            duration: animationDuration,
            ease: "linear" as const,
          }}
        />
      )}
    </motion.span>
  );
};
